import vuetify from '@/plugins/vuetify';
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import App from './App.vue';
import router from './router';
import store from './store';

const options = {
  position: 'bottom-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  maxToasts: 5,
};

Vue.use(Toast, options);
Vue.component('apexchart', VueApexCharts);
Vue.use(VueApexCharts);

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
});

app.$mount('#app');
